import React from "react"
import { Container, Row, Col, Form, Modal } from "react-bootstrap"
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from "@mui/material";
import axios from "axios";
import PhoneClinicGrid from "../../Components/PhoneClinicGrid";
import RowActions from "../../Components/PhoneClinicGrid/RowActions";
import AddIcon from "@mui/icons-material/Add";


class CommonServices extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            addService: false,
            ServicesList: [],
            UpdatedServiceList: [],


            showModal: false,
            SERVICE_ID: "",
            SERVICE_NAME: ""

        };
        this.gridRef = React.createRef(null);
    }

    // componentDidMount() {
    //     this.getAllServices(searchGridData, totalRecordsPerPage.value, paginationValue)
    // }

    async getAllServices(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };

        const getAllService = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllService.php`, formData);
        let serviceData = getAllService.data
        let UpdatedServiceList = [];
        if (serviceData.success === 1) {
            UpdatedServiceList = serviceData.data
            pagination.totalItems = parseInt(serviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ UpdatedServiceList })
        this.props.toggleLoader(false)
    }

    handleAddService() {
        let { ServicesList } = this.state;
        ServicesList.push({
            SERVICE_NAME: ""
        })
        this.setState({ ServicesList })
    }

    async handleChangeInput(indx, fieldName, evt) {
        let { ServicesList } = this.state;
        ServicesList[indx][fieldName] = evt.target.value
        this.setState({ ServicesList })
    }

    hanldeEditService() {
        this.setState({ addService: true, ServicesList: [] })
    }

    async handleSubmitService() {
        this.props.toggleLoader(true)
        let { ServicesList } = this.state;
        await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddService.php`, JSON.stringify(ServicesList));
        this.getAllServices()
        this.handleCancelService()
    }

    handleCancelService() {
        this.setState({
            addService: false,
            ServicesList: [],
            showModal: false,
            SERVICE_ID: "",
            SERVICE_NAME: ""
        })
    }

    handleRemoveService(indx) {
        let { ServicesList } = this.state;
        ServicesList.splice(indx, 1)
        this.setState({ ServicesList })
    }

    handleUpdateService(indx) {
        let { UpdatedServiceList } = this.state

        console.log('indx', indx)
        console.log('UpdatedServiceList', UpdatedServiceList)
        this.setState({
            showModal: true,
            SERVICE_ID: UpdatedServiceList[indx]['PCAS_ID'],
            SERVICE_NAME: UpdatedServiceList[indx]['PCAS_SERVICE_NAME']
        })
    }

    handleChange(fieldName, evnt) {
        this.setState({
            [fieldName]: evnt.target.value
        })
    }

    async handleUpdateServiceMutate() {
        let formData = {
            SERVICE_ID: this.state.SERVICE_ID,
            SERVICE_NAME: this.state.SERVICE_NAME
        }
        await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCUpdateService.php`, formData);
        this.setState({ showModal: false })
        this.getAllServices()
    }

    render() {
        let { addService } = this.state
        return (
            <Container>

                <PhoneClinicGrid
                    title="SERVICE"
                    buttonLabel={addService ? "Update Service" : "Edit Service"}
                    isEditable={!addService}
                    ref={this.gridRef}
                    getData={this.getAllServices.bind(this)}
                    onClickButton={addService ? this.handleSubmitService.bind(this) : this.hanldeEditService.bind(this)}
                    tableHeadData={[
                        {
                            label: "SERVICE",
                            isHidden: false
                        },
                        {
                            label: <Button variant="contained" size="small" startIcon={<AddIcon />} onClick={this.handleAddService.bind(this)} ></Button>,
                            isHidden: !addService
                        }
                    ]}
                >

                    {addService ?
                        this.state.ServicesList.map((service, idx) => (
                            <TableRow
                                className="table-rows"
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell component="th" scope="row">
                                    <Form.Control
                                        value={service.SERVICE_NAME}
                                        onChange={this.handleChangeInput.bind(this, idx, "SERVICE_NAME")}
                                        style={{ width: "100%" }}
                                    />
                                </TableCell>
                                <TableCell align='center'>
                                    {/* Add mode: removes this unsaved input line, not a stored record. */}
                                    <RowActions actions={[
                                        { type: 'delete', title: 'Remove line', onClick: this.handleRemoveService.bind(this, idx) },
                                    ]} />
                                </TableCell>
                            </TableRow>
                        ))
                        :
                        this.state.UpdatedServiceList.map((ServiceList, indx) => (
                            <TableRow
                                key={indx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            >
                                <TableCell align='left'>{ServiceList.PCAS_SERVICE_NAME}</TableCell>
                                <TableCell align='center'>
                                    <RowActions actions={[
                                        { type: 'edit', onClick: this.handleUpdateService.bind(this, indx) },
                                    ]} />
                                </TableCell>
                            </TableRow>

                        ))
                    }
                </PhoneClinicGrid>

                <Modal
                    show={this.state.showModal}
                    centered
                >

                    <Modal.Body>
                        <label>Service</label>
                        <Form.Control
                            value={this.state.SERVICE_NAME}
                            onChange={this.handleChange.bind(this, "SERVICE_NAME")}
                            style={{ width: "100%" }}
                        />
                    </Modal.Body>
                    <Modal.Footer>
                        <Button onClick={this.handleCancelService.bind(this)}>Cancel</Button>
                        <Button onClick={this.handleUpdateServiceMutate.bind(this)} >Update</Button>
                    </Modal.Footer>
                </Modal>
            </Container >
        );
    }
}

export default CommonServices;